import { all, call, delay, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  FLAG_CREATE_FAILURE,
  FLAG_CREATE_REQUEST,
  FLAG_CREATE_SUCCESS,
  FLAG_MISLABELED_CREATE_REQUEST,
} from "../actions/constants";
import { addToast, nextId, removeToast } from "../actions/toastActions";

function* createFlag(action: any): any {
  try {
    const flag = yield call(ApiService.createSlideFlag, {
      parentLookupSlideId: action.payload.form.slide_id,
      requestBody: action.payload.form,
    });
    yield put({
      type: FLAG_CREATE_SUCCESS,
      payload: {
        result: flag,
        isMislabel: false,
      },
    });
  } catch (e: any) {
    yield put({
      type: FLAG_CREATE_FAILURE,
      error: true,
      payload: e,
    });
  } finally {
    action.payload.closeModal(false);
  }
}

function* createMislabeledFlag(action: any): any {
  try {
    const flag = yield call(ApiService.createSlideFlag, {
      parentLookupSlideId: action.payload.form.slide_id,
      requestBody: action.payload.form,
    });
    const id = nextId();
    const toastStr =
      action.payload.url && action.payload.url.includes("slides")
        ? "Slide"
        : "Case";
    yield all([
      put({
        type: FLAG_CREATE_SUCCESS,
        payload: {
          result: flag,
          isMislabel: true,
        },
      }),
      put(
        addToast(
          {
            kind: "success",
            title: `${toastStr} has been moved`,
            message:
              `${toastStr} has been moved back to the QC team to review the mislabeled slide.\\n` +
              `For patient safety the ${toastStr.toLowerCase()} is no longer visible until that has been resolved.`,
          },
          id
        )
      ),
    ]);
    action.payload.closeModal(false);
    if (action.payload.navigate && action.payload.url) {
      action.payload.navigate(action.payload.url, { replace: true });
    }
    yield delay(4000);
    yield put(removeToast(id));
  } catch (e: any) {
    yield put({
      type: FLAG_CREATE_FAILURE,
      error: true,
      payload: e,
    });
    action.payload.closeModal(false);
  }
}

export function* flagsSaga() {
  yield takeLatest(FLAG_CREATE_REQUEST, createFlag);
  yield takeLatest(FLAG_MISLABELED_CREATE_REQUEST, createMislabeledFlag);
}
